var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import id from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import DealSavingsTypes from "@irati/deals/types/enums/DealSavingsType";
import SpecialRates from "./SpecialRates";
import Free from "./Free";
import Amount from "./Amount";
import SavingsWrapper from "./styles/SavingsWrapper";
var Saving = /** @class */ (function (_super) {
    __extends(Saving, _super);
    function Saving() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Saving.prototype.render = function () {
        var _a = this.props, saving = _a.saving, type = _a.type, addSavingsTypeEmoji = _a.addSavingsTypeEmoji, header = _a.header, className = _a.className, currency = _a.currency, smallSavingsHeader = _a.smallSavingsHeader;
        var idNamespace = id("saving", this.props);
        var birthdayEmoji = addSavingsTypeEmoji ? "🎂" : "";
        var savingsBlock = null;
        if (type === DealSavingsTypes.SPECIAL_RATES) {
            savingsBlock = React.createElement(SpecialRates, { id: id("special-rates", idNamespace), small: smallSavingsHeader });
        }
        else if (type === DealSavingsTypes.FREE) {
            savingsBlock = React.createElement(Free, { id: id("free", idNamespace), emoji: birthdayEmoji, small: smallSavingsHeader });
        }
        else if (saving) {
            savingsBlock = (React.createElement(Amount, { idNamespace: idNamespace, savingsType: type, savingsValue: saving, savingsHeader: header, currency: currency, small: smallSavingsHeader }));
        }
        return (React.createElement(SavingsWrapper, { id: id("savings-wrapper", idNamespace), className: className, "data-test": "savings" }, savingsBlock));
    };
    Saving.defaultProps = {
        currency: "",
        addSavingsTypeEmoji: false
    };
    return Saving;
}(PureComponent));
export default injectIntl(Saving);
